import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Button } from "@climatepartner/components";
import { Layout } from "../../components/Layout";
import { useAuthenticationContext } from "../../providers/AuthenticationContext";
export function DashboardLayout({ header, children, theme, slots, sidebar, linkComponent: LinkComponent, cimUrl, }) {
    const { user, enabledServices, actions } = useAuthenticationContext();
    const renderFooterMenu = () => {
        return [...(sidebar?.footerMenu || [])];
    };
    const middleSlotContent = header?.slots?.middle ?? "";
    return (_jsx(Layout, { theme: theme, header: {
            user,
            slots: {
                middle: (_jsxs(Box, { sx: { display: "flex", alignItems: "center" }, children: [middleSlotContent, actions.hasPermission("cphub.employee.access") && cimUrl && (_jsx(Button, { sx: middleSlotContent !== "" ? { marginLeft: 2 } : undefined, size: "small", href: cimUrl, children: "Go back to CIM" }))] })),
            },
            logoUrl: "/",
        }, slots: slots, sidebar: {
            services: enabledServices,
            customMenuItems: sidebar?.customMenuItems,
            footerMenu: renderFooterMenu(),
            currentServiceId: sidebar.currentServiceId,
        }, linkComponent: LinkComponent, actions: actions, children: children }));
}
//# sourceMappingURL=DashboardLayout.js.map